import * as types from "../constants/ActionTypes";
var initialState = {
  modalYearlyPlan: false,
  modalYearlyPlanEnhance: false,
  modalCharge: false,
  planTableState: {
    selectOptionsOverQuota: "1",
    modalStatus: false,
    rangeDayProcess: "30",
    choosePlan: "",
    chooseSubscription: "monthly",
    tabSelected: 0,
  },
  yearEndWrap: false,
  yearEndData: {
    dispute_resolved: "0",
    order_synced: "0",
    paypal: "0",
    stripe: "0",
  },
  hasYearEnd: false,
};

var commonSetting = (state = initialState, action) => {
  switch (action.type) {
    case types.FECTH_MODAL_YEARLY_PLAN:
      state.modalYearlyPlan = action.payload;
      return { ...state };
    case types.FECTH_MODAL_YEARLY_PLAN_ENHANCE:
      state.modalYearlyPlanEnhance = action.payload;
      return { ...state };
    case types.FETCH_MODAL_CHARGE:
      state.modalCharge = action.payload;
      return { ...state };
    case types.FETCH_YEAR_END_WRAP:
      state.yearEndWrap = action.payload;
      return { ...state };
    case types.SET_YEAR_END_DATA:
      state.yearEndData = action.payload;
      return { ...state };
    case types.FETCH_HAS_YEAR_END:
      state.hasYearEnd = action.payload;
      return { ...state };
    default:
      return { ...state };
  }
};
export default commonSetting;
